/**
 * PageEmptyState — the `!effectiveHtml` early-return branch of PageRenderer.
 *
 * Two presentations:
 *   - A freshly-created page (created_at < 30s ago) is "likely building", so we
 *     show the pulsing-favicon build loader (`xavior-build-loader`) instead of
 *     an empty message — the live build stream is expected to populate it. The
 *     live-build test asserts this markup.
 *   - Otherwise we show the "No content to display" module-content fallback.
 */

interface PageEmptyStateProps {
  object: any;
}

export default function PageEmptyState({ object }: PageEmptyStateProps) {
  const createdAt = object?.created_at || object?.createdAt;
  const ageMs = createdAt ? Date.now() - new Date(createdAt).getTime() : Infinity;
  const isLikelyBuilding = ageMs < 30_000;

  if (isLikelyBuilding) {
    return (
      <div
        className="module"
        style={{ display: 'flex', flexDirection: 'column', flex: 1, height: '100%', minHeight: 0 }}
      >
        <div className="xavior-build-loader">
          <div className="xavior-build-loader__logo-wrap">
            <div className="xavior-build-loader__glow" />
            <img src="/favicon.svg" alt="Xavior" className="xavior-build-loader__logo" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="module"
      style={{ display: 'flex', flexDirection: 'column', flex: 1, height: '100%', minHeight: 0 }}
    >
      <div
        className="module-content"
        style={{ padding: 16, color: 'var(--color-text-secondary)', flex: 1, minHeight: 0 }}
      >
        No content to display. The agent can create visualizations here.
      </div>
    </div>
  );
}
